'use strict';

angular.module('web2print.newAddress')
  .controller('individualsController', function (individualsFactory, $timeout, $scope, $filter, recipientsFactory, Common, addressCalculationFactory, postalCodesFactory) {
    const vm = this;
    let refinedTimeout;

    // TODO: move this to factory
    function checkModels (models) {
      let allVal = true;

      models.forEach(function (item) {
        if (item.modelKey !== 'all' && !item.selected) {
          allVal = false;
        }
      });

      models[0].selected = allVal;
    }

    // TODO: move this on factory
    function selectModel (model, groupKey) {
      if (model.modelKey === 'all') {
        vm[groupKey].forEach(function (item) {
          if (item.modelKey !== 'all') {
            item.selected = vm[groupKey][0].selected;
          }
        });
      } else {
        vm.checkModels(vm[groupKey]);
      }

    }

    function showFormClicked () {
      if (vm.showArea) {
        vm.showForm = !vm.showForm;
      }
    }

    function showAreaClicked () {
      vm.showArea = !vm.showArea;

      if (!vm.showArea) {
        vm.showForm = false;
      }
    }

    function refreshSlider () {
      $timeout(function () {
        $scope.$broadcast('rzSliderForceRender');
      });
    }

    function hasSelected (arr) {
      let selected = 0;
      arr.forEach(function (item) {
        if (item.selected) {
          selected++;
        }
      });
      return selected !== 0;
    }

    function getSelected (key, validation) {
      // validation === true when this function is invoked for validation
      // sets an empty array as default or all
      let selected = [];

      if (!vm[key][0].selected) {
        vm[key].forEach(function (item) {
          if (item.selected && item.number) {
            selected.push(item.number);
          }
        });
      } else {
        if (validation) {
          selected = [0];
        }
      }

      return selected;
    }

    function getPowerRange () {
      const range = [];
      const min = vm.slider.min;
      const max = vm.slider.max;

      if (min === 1 && max === 6) { // don't filter if everything is selected
        return null;
      }

      for (let x = min; x <= max; x++) {
        range.push(x);
      }

      return range;
    }

    function canSubmitZip () {
      return !vm.grossCountSynced && !vm.grossRecipientsLoading && validZipcodes();
    }

    function constructADRData () {
      return {
        minAge: vm.minAge !== '' ? vm.minAge : null,
        maxAge: vm.maxAge !== '' ? vm.maxAge : null,
        gender: vm.gender,
        formOfHousing: getSelected('lodging').length ? getSelected('lodging') : null, // setting it to null if all
        householdType: getSelected('householdTypes').length ? getSelected('householdTypes') : null, // setting it to null if all
        purchasingPower: getPowerRange()
      };
    }

    function refreshAddressCount () {
      addressCalculationFactory.computeAddressCount(constructADRData());
    }

    function validRefine () {
      return vm.gender && vm.slider;
    }

    function validZipcodes () {
      return postalCodesFactory.zipcodes && postalCodesFactory.zipcodes.length;
    }

    function isFetchingGrossCount () {
      return addressCalculationFactory.getUpdateSyncParams().isFetchingGrossCount;
    }

    function isFetchingRefinedCount () {
      return addressCalculationFactory.getUpdateSyncParams().isFetchingRefinedCount;
    }

    function hasChangedRefined () {
      $timeout.cancel(refinedTimeout);
      const params = constructADRData();
      if (validRefine() && validZipcodes()) {
        refinedTimeout = $timeout(() => {
          addressCalculationFactory.computeRefinedCount(params);
        }, 800);
      }
    }


    function activate () {
      vm.grossRecipientsLoading = false;
      vm.refinedRecipientsLoading = false;
      vm.addressLimit = recipientsFactory.addressLimit; // min/max values for amount of recipients
      vm.slider = {
        options: {
          showTicks: true,
          showTicksValues: false,
          pushRange: true,
          minRange: 1,
          mergeRangeLabelsIfSame: true,
          stepsArray: [
            {value: 1, legend: $filter('translate')('LOW')},
            {value: 2},
            {value: 3},
            {value: 4},
            {value: 5},
            {value: 6, legend: $filter('translate')('HIGH')}
          ],
          onEnd: hasChangedRefined,
          translate: function (value, id, label) {
            // no labels
            return '';
          }
        }
      };

      const adrData = Common.get('adrData', {});
      // initialise zipcodes in addressCalculation
      postalCodesFactory.setPostalCodesSelectedAreas();
      addressCalculationFactory.setRefinedGross();
      // empty object makes sure we don't get any null/undefined errors

      // field defaults
      vm.minAge = adrData.minAge;
      vm.maxAge = adrData.maxAge;
      vm.gender = adrData.gender || 'both';
      vm.slider = individualsFactory.getSliderVal(vm.slider, adrData.purchasingPower || [1, 2, 3, 4, 5, 6]);
      vm.grossCount = Common.get('recipients.grossAddressCount', null);
      vm.count = Common.get('recipients.refinedAddressCount', null);
      vm.lodging = individualsFactory.getFilters(adrData.formOfHousing, 'lodging');
      vm.householdTypes = individualsFactory.getFilters(adrData.householdType, 'householdTypes');

      // methods
      vm.hasChangedRefined = hasChangedRefined;
      vm.selectModel = selectModel;
      vm.checkModels = checkModels;
      vm.showFormClicked = showFormClicked;
      vm.showAreaClicked = showAreaClicked;
      vm.refreshSlider = refreshSlider;
      vm.refreshAddressCount = refreshAddressCount;
      vm.validRefine = validRefine;
      vm.validZipcodes = validZipcodes;
      vm.canSubmitZip = canSubmitZip;
      vm.hasSelected = hasSelected;
      vm.formatNumber = Common.formatNumber;
      vm.isFetchingRefinedCount = isFetchingRefinedCount;
      vm.isFetchingGrossCount = isFetchingGrossCount;
      vm.showError = addressCalculationFactory.showError;
      vm.formatNumberForSummary = addressCalculationFactory.formatNumberForSummary;
      vm.constructADRData = constructADRData;

      if (validRefine()) {
        refreshAddressCount();
      }

      console.log('IndividualsCtrl activated');
    }

    activate();
  });
